<template>
  <div id="body">
    <base-navigation />

    <base-card>

      <div id="element-to-convert">

        <!-- HEADER -->
        <div class="row">
          <div class="col-lg-6">
            <img
              width="120"
              height="100"
              src="../../assets/gafwa_logo.png"
            />
          </div>

               <div class="col-lg-6">
            Gusii advocates first welfare 
            <br />
            Benevolent welfare for members
            <br />
           
            gafwa.roberms.com, gafwawelfare@gmail.com

            <!-- {{ memberdetails }} -->
          </div>
        </div>

        <!-- REPORT TITLE -->
        <div class="row mt-3">
          <div class="col-lg-7">
            <small><b>Membership Contributions Report</b></small>
          </div>
          <div class="col-lg-5 text-info">
            <small>{{ currentDate }}</small>
          </div>
        </div>

        <br />

        <!-- ========================= -->
        <!-- TABLE (ONLY LAST 12 CASES) -->
        <!-- ========================= -->

        <div v-if="memberdetails.length > 0">

          <div style="overflow-x:auto;">

            <table class="table table-bordered table-sm myFormat">

              <thead>
                <tr>
                  <th>No.</th>
                  <th>Name</th>
                  <th>Court</th>
                  <th>Reg</th>
                  <th>Buffer</th>

                  <th
                    v-for="caseItem in last12Cases"
                    :key="'header' + caseItem.case_id"
                  >
                    C{{ caseItem.case_id }}
                  </th>
                </tr>
              </thead>

              <tbody>

                <tr
                  v-for="member in memberdetails"
                  :key="member.id"
                >
                  <td>{{ member.membership_number }}</td>
                  <td>{{ member.memberNames || '-' }}</td>
                  <td>{{ member.memberCourt || '-' }}</td>

                  <td>{{ getMemberValue(member, 'registration_amount') }}</td>
                  <td>{{ getMemberValue(member, 'buffer_amount') }}</td>

                  <td
                    v-for="caseItem in last12Cases"
                    :key="'case' + caseItem.case_id"
                  >
                    {{ getMemberValue(member, `case_${caseItem.case_id}_amount`) }}
                  </td>

                </tr>

              </tbody>

            </table>

          </div>

        </div>

        <div v-else class="text-center text-muted">
          No member data available.
        </div>

        <br /><br />

        <!-- ========================= -->
        <!-- FULL SUMMARY (ALL CASES) -->
        <!-- ========================= -->

        <div class="card p-3">

          <h6>Contribution Summary (All Cases)</h6>

          <div class="row">

            <div
              v-for="caseItem in sortedCases"
              :key="caseItem.case_id"
              class="col-lg-3 col-md-4 col-sm-6 mb-2"
            >
              <small>
                Case {{ caseItem.case_id }} :
                <b class="text-danger">
                  {{ getCaseTotal(caseItem.case_id) }}
                </b>
                <br />
                <i>{{ formatDate(caseItem.payment_date) }}</i>
              </small>
            </div>

          </div>

          <hr />

          <div class="row">

            <div class="col-lg-4">
              <small>
                Registration Total:
                <b class="text-danger">{{ totalRegistration }}</b>
              </small>
            </div>

            <div class="col-lg-4">
              <small>
                Buffer Total:
                <b class="text-danger">{{ totalBuffer }}</b>
              </small>
            </div>

            <div class="col-lg-4">
              <small>
                Overall Total Collected:
                <b class="text-success">{{ overallTotal }}</b>
              </small>
            </div>

          </div>

        </div>

      </div>

      <br />

      <button class="btn btn-primary" @click="exportToPDF">
        Download PDF
      </button>

      <br /><br />

      <router-link to="/">Go back</router-link>

    </base-card>
  </div>
</template>

<script>
import html2pdf from "html2pdf.js";

export default {

  name: "MembershipReport",

  computed: {

    memberdetails() {
      return this.$store.getters.allMembers || [];
    },

    someMembers() {
      return this.$store.getters.newmembers || [];
    },

    cases() {
      return this.$store.getters.cases || [];
    },

    /* LAST 12 FOR TABLE */
    last12Cases() {
      return [...this.cases]
        .sort((a, b) => a.case_id - b.case_id)
        .slice(-12);
    },

    /* ALL CASES SORTED */
    sortedCases() {
      return [...this.cases]
        .sort((a, b) => a.case_id - b.case_id);
    },

    currentDate() {
      return new Date().toLocaleString("nl-NL");
    },

    totalRegistration() {
      return this.sumField("registration_amount");
    },

    totalBuffer() {
      return this.sumField("buffer_amount");
    },

    /* GRAND TOTAL OF EVERYTHING */
    overallTotal() {
      let total = this.totalRegistration + this.totalBuffer;

      this.sortedCases.forEach(c => {
        total += this.getCaseTotal(c.case_id);
      });

      return total;
    }

  },

  methods: {

    sumField(field) {
      return this.someMembers.reduce(
        (acc, item) => acc + parseInt(item[field] || 0),
        0
      );
    },

    getCaseTotal(caseId) {
      return this.someMembers.reduce(
        (acc, item) =>
          acc + parseInt(item[`case_${caseId}_amount`] || 0),
        0
      );
    },

    getMemberValue(member, field) {
      const index = Math.ceil(parseInt(member.membership_number) - 1000);
      const data = this.$store.getters.joiningMember(index);

      return data && data.length > 0
        ? data[0][field] || 0
        : 0;
    },

    formatDate(date) {
      return date ? date.split("T")[0] : "No date";
    },

    exportToPDF() {
      const element = document.getElementById("element-to-convert");

      html2pdf(element, {
        margin: [0, 10, 0, 10],
        filename:
          "Contributions as at " +
          new Date().toLocaleString("nl-NL").split(",")[0] +
          ".pdf",
        image: { type: "jpeg", quality: 0.98 },
        html2canvas: { dpi: 192, scale: 2 },
        jsPDF: { unit: "mm", format: "a3", orientation: "portrait" }
      });
    }

  },

  created() {
    this.$store.dispatch("Loadmembers");
    this.$store.dispatch("LoadPayments");
    this.$store.dispatch("LoadNewmembers");
    this.$store.dispatch("LoadCases");
  }

};
</script>

<style scoped>
table.myFormat tr td {
  font-size: 12px;
}
</style>
